/*
 *
 * RubiconePromoCarouselPopup
 *
 * @version 1.0.0
 * @author Lucio Chiummo
 * @since 25-Aug-2025
*/

import RubiconePromoCarouselPopup from './RubiconePromoCarouselPopupContainer'

export default RubiconePromoCarouselPopup
